
// // import React, { useEffect, useState } from "react";
// // import { useParams } from "react-router-dom";
// // import HeroSlider from "../components/HeroSlider";
// // import Footer from "../components/Footer";
// // import DynamicImage from "../components/DynamicImage";

// // const imageCategories = {
// //   "koltuk-yikama": [
// //     { type: "image", src: "/images/aktar/koltuk/koltuk1.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk2.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk3.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk4.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk5.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk6.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk7.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk8.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk9.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk10.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk11.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk12.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk13.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk14.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk15.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk16.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk17.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk18.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk19.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk20.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk21.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk22.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk23.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk24.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk25.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk26.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk27.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk28.png" },
// //     { type: "image", src: "/images/aktar/koltuk/koltuk29.png" },
// //   ],
// //   "hali-yikama": [
// //     { type: "image", src: "/images/aktar/hali/hali1.png" },
// //     { type: "image", src: "/images/aktar/hali/hali2.png" },
// //     { type: "image", src: "/images/aktar/hali/hali3.png" },
// //     { type: "image", src: "/images/aktar/hali/hali4.png" },
// //     { type: "image", src: "/images/aktar/hali/hali5.png" },
// //     { type: "image", src: "/images/aktar/hali/hali6.png" },
// //     { type: "image", src: "/images/aktar/hali/hali7.png" },
// //     { type: "image", src: "/images/aktar/hali/hali8.png" },
// //     { type: "image", src: "/images/aktar/hali/hali11.png" },
// //     { type: "image", src: "/images/aktar/hali/hali12.png" },
// //     { type: "image", src: "/images/aktar/hali/hali13.png" },
// //     { type: "image", src: "/images/aktar/hali/hali14.png" },
// //       { type: "image", src: "/images/aktar/hali/hali16.png" },
// //     { type: "image", src: "/images/aktar/hali/hali15.png" },
  
// //     { type: "image", src: "/images/aktar/hali/hali10.png" },
   
// //   ],
// //   videolar: [
// //     { type: "video", src: "/videos/1.mp4" },
// //     { type: "video", src: "/videos/2.mp4" },
// //     { type: "video", src: "/videos/3.mp4" },
// //     { type: "video", src: "/videos/4.mp4" },
// //     { type: "video", src: "/videos/9.mp4" },
// //     { type: "video", src: "/videos/10.mp4" },
// //     { type: "video", src: "/videos/11.mp4" },
// //     { type: "video", src: "/videos/12.mp4" },
// //     { type: "video", src: "/videos/13.mp4" },
// //     { type: "video", src: "/videos/14.mp4" },
// //     { type: "video", src: "/videos/15.mp4" },
// //     { type: "video", src: "/videos/16.mp4" },
// //   ],
// // };

// // function slugNormalize(str) {
// //   return str
// //     .toLowerCase()
// //     .replace(/ı/g, "i")
// //     .replace(/ğ/g, "g")
// //     .replace(/ü/g, "u")
// //     .replace(/ş/g, "s")
// //     .replace(/ö/g, "o")
// //     .replace(/ç/g, "c");
// // }

// // const GaleryPage = () => {
// //   const { slug } = useParams();
// //   const [selectedImage, setSelectedImage] = useState(null);
// //   const [images, setImages] = useState([]);

// //   useEffect(() => {
// //     const normalizedSlug = slugNormalize(slug);
// //     const media = imageCategories[normalizedSlug] || [];
// //     setImages(media);
// //   }, [slug]);

// //   return (
// //     <>
// //       {/* HeroSlider sadece md ve üzeri ekranlarda */}
// //       <div className="hidden md:block">
// //         <HeroSlider />
// //       </div>

// //       {/* Sadece mobilde 8.png logosu gösterilecek */}
// //       <div className="block md:hidden max-w-4xl mx-auto px-4 text-center mt-1">
// //         <img
// //           src="/images/8.png"
// //           alt="Logo"
// //           className="h-20 sm:h-28 mx-auto mb-4"
// //           style={{ maxWidth: "100%", height: "auto" }}
// //         />
// //       </div>

// //       {/* Açıklama kısmı her ekranda gösterilecek */}
// //       <div className="max-w-4xl mx-auto px-4 mb-12 text-gray-800 text-center">
// //         <p className="text-lg md:text-xl font-semibold mb-4 text-primary capitalize">
// //           {slug.replace("-", " ")} Medya Galerisi Hakkında
// //         </p>
// //         <p className="text-base md:text-lg leading-relaxed mb-4 text-justify">
// //           Bu bölümde <strong>{slug.replace("-", " ")}</strong> kategorisine ait <strong>gerçek iş süreçlerinden alınmış fotoğraf ve video içeriklerine</strong> ulaşabilirsiniz.
// //           Hizmet öncesi-sonrası farkları, kullanılan ekipmanlar ve temizlik teknikleri bu içeriklerde açıkça görülmektedir.
// //         </p>
// //         <p className="text-base md:text-lg leading-relaxed mb-4 text-justify">
// //           Abone Halı Yıkama olarak sunduğumuz hizmetlerde <strong>organik deterjan kullanımı</strong>,
// //           <strong>güncel makineler</strong> ve <strong>hijyen kurallarına tam uyum</strong> ile sektörde fark yaratıyoruz.
// //           Görsellerimizde yer alan tüm işlemler, gerçek müşteri siparişlerinden alınmıştır.
// //         </p>
// //       </div>

// //       <div className="min-h-screen bg-white">
// //         {images.length === 0 ? (
// //           <p className="text-center text-red-500">Hiç fotoğraf bulunamadı.</p>
// //         ) : (
// //           <div className="max-w-6xl mx-auto px-4 pb-16">
// //             <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
// //               {images.map((item, i) => (
// //                 <div key={i} className="text-center">
// //                   {item.type === "image" ? (
// //                     <img
// //                       src={item.src}
// //                       onClick={() => setSelectedImage(item.src)}
// //                       className="w-full h-auto object-cover rounded-lg cursor-pointer shadow hover:scale-105 transition"
// //                       alt={`foto-${i}`}
// //                     />
// //                   ) : (
// //                     <video controls className="w-full h-auto rounded-lg shadow">
// //                       <source src={item.src} type="video/mp4" />
// //                       Tarayıcınız video etiketini desteklemiyor.
// //                     </video>
// //                   )}
// //                   <p className="mt-2 text-sm font-semibold text-gray-700">
// //                     Abone Halı Yıkama
// //                   </p>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>
// //         )}

// //         {selectedImage && (
// //           <div
// //             className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center"
// //             onClick={() => setSelectedImage(null)}
// //           >
// //             <div className="relative max-w-3xl w-full px-4">
// //               <button
// //                 onClick={() => setSelectedImage(null)}
// //                 className="absolute top-2 right-4 text-white text-3xl"
// //               >
// //                 ✕
// //               </button>
// //               <img
// //                 src={selectedImage}
// //                 alt="büyük görsel"
// //                 className="w-full max-h-[90vh] object-contain rounded-lg"
// //               />
// //             </div>
// //           </div>
// //         )}

// //         <div className="max-w-4xl mx-auto px-4 mb-12 text-gray-800 text-center">
// //           <p className="text-base md:text-lg leading-relaxed text-justify">
// //             Bu sayede firmamızın çalışma prensiplerini ve hizmet kalitesini <strong>doğrudan gözlemleyebilir</strong>, tercih etmeden önce gönül rahatlığıyla değerlendirme yapabilirsiniz.
// //           </p>
// //         </div>
// //       </div>
// //       <Footer />
// //     </>
// //   );
// // };

// // export default GaleryPage;
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import HeroSlider from "../components/HeroSlider";
// import Footer from "../components/Footer";

// const imageCategories = {
//   "koltuk-yikama": [
//     { type: "image", src: "/images/aktar/koltuk/koltuk1.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk2.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk3.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk4.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk5.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk6.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk7.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk8.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk9.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk10.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk11.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk12.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk13.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk14.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk15.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk16.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk17.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk18.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk19.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk20.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk21.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk22.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk23.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk24.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk25.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk26.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk27.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk28.png" },
//     { type: "image", src: "/images/aktar/koltuk/koltuk29.png" },
//   ],
//   "hali-yikama": [
//     { type: "image", src: "/images/aktar/hali/hali1.png" },
//     { type: "image", src: "/images/aktar/hali/hali2.png" },
//     { type: "image", src: "/images/aktar/hali/hali3.png" },
//     { type: "image", src: "/images/aktar/hali/hali4.png" },
//     { type: "image", src: "/images/aktar/hali/hali5.png" },
//     { type: "image", src: "/images/aktar/hali/hali6.png" },
//     { type: "image", src: "/images/aktar/hali/hali7.png" },
//     { type: "image", src: "/images/aktar/hali/hali8.png" },
//     { type: "image", src: "/images/aktar/hali/hali11.png" },
//     { type: "image", src: "/images/aktar/hali/hali12.png" },
//     { type: "image", src: "/images/aktar/hali/hali13.png" },
//     { type: "image", src: "/images/aktar/hali/hali14.png" },
//       { type: "image", src: "/images/aktar/hali/hali16.png" },
//     { type: "image", src: "/images/aktar/hali/hali15.png" },
  
//     { type: "image", src: "/images/aktar/hali/hali10.png" },
   
//   ],
//   videolar: [
//     { type: "video", src: "/videos/1.mp4" },
//     { type: "video", src: "/videos/2.mp4" },
//     { type: "video", src: "/videos/3.mp4" },
//     { type: "video", src: "/videos/4.mp4" },
//     { type: "video", src: "/videos/9.mp4" },
//     { type: "video", src: "/videos/10.mp4" },
//     { type: "video", src: "/videos/11.mp4" },
//     { type: "video", src: "/videos/12.mp4" },
//     { type: "video", src: "/videos/13.mp4" },
//     { type: "video", src: "/videos/14.mp4" },
//     { type: "video", src: "/videos/15.mp4" },
//     { type: "video", src: "/videos/16.mp4" },
//   ],
// };

// function slugNormalize(str) {
//   return str
//     .toLowerCase()
//     .replace(/ı/g, "i")
//     .replace(/ğ/g, "g")
//     .replace(/ü/g, "u")
//     .replace(/ş/g, "s")
//     .replace(/ö/g, "o")
//     .replace(/ç/g, "c");
// }

// const GaleryPage = () => {
//   const { slug } = useParams();
//   const [selectedImage, setSelectedImage] = useState(null);
//   const [images, setImages] = useState([]);

//   useEffect(() => {
//     const normalizedSlug = slugNormalize(slug);
//     const media = imageCategories[normalizedSlug] || [];
//     setImages(media);
//   }, [slug]);

//   return (
//     <>
//       <div className="hidden md:block">
//         <HeroSlider />
//       </div>
// {/* 
//       <div className="block md:hidden max-w-4xl mx-auto px-4 text-center mt-1">
//         <img
//           src="/images/8.png"
//           alt="Logo"
//           width={160}
//           height={80}
//           className="h-20 sm:h-28 mx-auto mb-4"
//         />
//       </div> */}

//       <div className="max-w-4xl mx-auto px-4 mb-12 text-gray-800 text-center pt-30">
//         <p className="text-lg md:text-xl font-semibold mb-4 text-primary capitalize">
//           {slug.replace(/-/g, " ")} Medya Galerisi Hakkında
//         </p>
//         <p className="text-base md:text-lg leading-relaxed mb-4 text-justify">
//           Bu bölümde <strong>{slug.replace(/-/g, " ")}</strong> kategorisine ait <strong>gerçek iş süreçlerinden alınmış fotoğraf ve video içeriklerine</strong> ulaşabilirsiniz.
//         </p>
//         <p className="text-base md:text-lg leading-relaxed mb-4 text-justify">
//           Abone Halı Yıkama olarak sunduğumuz hizmetlerde <strong>organik deterjan kullanımı</strong>, <strong>güncel makineler</strong> ve <strong>hijyen kurallarına tam uyum</strong> ile sektörde fark yaratıyoruz.
//         </p>
//       </div>

//       <div className="min-h-screen bg-white">
//         {images.length === 0 ? (
//           <p className="text-center text-red-500">Hiç fotoğraf bulunamadı.</p>
//         ) : (
//           <div className="max-w-6xl mx-auto px-4 pb-16">
//             <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
//               {images.map((item, i) => (
//                 <div key={i} className="text-center">
//                   {item.type === "image" ? (
//                     <img
//                       src={item.src}
//                       loading="lazy"
//                       width={400}
//                       height={300}
//                       onClick={() => setSelectedImage(item.src)}
//                       className="w-full h-auto object-contain rounded-lg cursor-pointer shadow hover:scale-105 transition"
//                       alt={`foto-${i}`}
//                     />
//                   ) : (
//                     <video
//                       controls
//                       width={400}
//                       height={300}
//                       className="w-full h-auto rounded-lg shadow"
//                     >
//                       <source src={item.src} type="video/mp4" />
//                       Tarayıcınız video etiketini desteklemiyor.
//                     </video>
//                   )}
//                   <p className="mt-2 text-sm font-semibold text-gray-700">
//                     Abone Halı Yıkama
//                   </p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}

//         {selectedImage && (
//           <div
//             className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center"
//             onClick={() => setSelectedImage(null)}
//           >
//             <div className="relative max-w-3xl w-full px-4">
//               <button
//                 onClick={() => setSelectedImage(null)}
//                 className="absolute top-2 right-4 text-white text-3xl"
//               >
//                 ✕
//               </button>
//               <img
//                 src={selectedImage}
//                 alt="büyük görsel"
//                 className="w-full max-h-[90vh] object-contain rounded-lg"
//               />
//             </div>
//           </div>
//         )}

//         <div className="max-w-4xl mx-auto px-4 mb-12 text-gray-800 text-center">
//           <p className="text-base md:text-lg leading-relaxed text-justify">
//             Bu sayede firmamızın çalışma prensiplerini ve hizmet kalitesini <strong>doğrudan gözlemleyebilir</strong>, tercih etmeden önce gönül rahatlığıyla değerlendirme yapabilirsiniz.
//           </p>
//         </div>
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default GaleryPage;
import React, { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import HeroSlider from "../components/HeroSlider";
import Footer from "../components/Footer";

const imageCategories = {
  "koltuk-yikama": [
    { type: "image", src: "/images/aktar/koltuk/koltuk1.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk2.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk3.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk4.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk5.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk6.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk7.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk8.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk9.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk10.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk11.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk12.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk13.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk14.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk15.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk16.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk17.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk18.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk19.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk20.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk21.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk22.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk23.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk24.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk25.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk26.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk27.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk28.png" },
    { type: "image", src: "/images/aktar/koltuk/koltuk29.png" },
  ],
  "hali-yikama": [
    { type: "image", src: "/images/aktar/hali/hali1.png" },
    { type: "image", src: "/images/aktar/hali/hali2.png" },
    { type: "image", src: "/images/aktar/hali/hali3.png" },
    { type: "image", src: "/images/aktar/hali/hali4.png" },
    { type: "image", src: "/images/aktar/hali/hali5.png" },
    { type: "image", src: "/images/aktar/hali/hali6.png" },
    { type: "image", src: "/images/aktar/hali/hali7.png" },
    { type: "image", src: "/images/aktar/hali/hali8.png" },
    { type: "image", src: "/images/aktar/hali/hali11.png" },
    { type: "image", src: "/images/aktar/hali/hali12.png" },
    { type: "image", src: "/images/aktar/hali/hali13.png" },
    { type: "image", src: "/images/aktar/hali/hali14.png" },
    { type: "image", src: "/images/aktar/hali/hali16.png" },
    { type: "image", src: "/images/aktar/hali/hali15.png" },
    { type: "image", src: "/images/aktar/hali/hali10.png" },
  ],
  videolar: [
    { type: "video", src: "/videos/1.mp4" },
    { type: "video", src: "/videos/2.mp4" },
    { type: "video", src: "/videos/3.mp4" },
    { type: "video", src: "/videos/4.mp4" },
    { type: "video", src: "/videos/9.mp4" },
    { type: "video", src: "/videos/10.mp4" },
    { type: "video", src: "/videos/11.mp4" },
    { type: "video", src: "/videos/12.mp4" },
    { type: "video", src: "/videos/13.mp4" },
    { type: "video", src: "/videos/14.mp4" },
    { type: "video", src: "/videos/15.mp4" },
    { type: "video", src: "/videos/16.mp4" },
  ],
};

function slugNormalize(str = "") {
  return str
    .toLowerCase()
    .replace(/ı/g, "i")
    .replace(/ğ/g, "g")
    .replace(/ü/g, "u")
    .replace(/ş/g, "s")
    .replace(/ö/g, "o")
    .replace(/ç/g, "c");
}

function formatTitle(slug = "") {
  return slug
    .replace(/-/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

const GaleryPage = () => {
  const { slug = "koltuk-yikama" } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);
  const [mediaItems, setMediaItems] = useState([]);

  const normalizedSlug = slugNormalize(slug);
  const pageTitle = useMemo(() => formatTitle(slug), [slug]);

  useEffect(() => {
    setMediaItems(imageCategories[normalizedSlug] || []);
  }, [normalizedSlug]);

  const imageCount = mediaItems.filter((item) => item.type === "image").length;
  const videoCount = mediaItems.filter((item) => item.type === "video").length;

  return (
    <>
      <div className="hidden md:block mt-80">
        <HeroSlider />
      </div>

      <main className="bg-gradient-to-b from-[#f8fafc] via-[#fffaf0] to-[#eef7f1] mt-11">
        <section className="relative overflow-hidden px-4 pt-8 pb-10 md:pt-14">
          <div className="absolute -top-32 -left-32 h-80 w-80 rounded-full bg-[#d6b56d]/25 blur-3xl" />
          <div className="absolute top-32 -right-32 h-96 w-96 rounded-full bg-emerald-200/30 blur-3xl" />

          <div className="relative max-w-screen-xl mx-auto mt-30">
            {/* <div className="block md:hidden text-center mb-8">
              <img
                src="/images/8.png"
                alt="Abone Halı Yıkama Logo"
                width={180}
                height={90}
                className="h-24 mx-auto object-contain"
              />
            </div> */}

            <div className="mx-auto max-w-4xl text-center">
              <span className="inline-flex rounded-full border border-[#d6b56d]/50 bg-white/90 px-5 py-2 text-sm font-bold text-[#6b3b16] shadow-sm">
                Gerçek İşlerden Fotoğraf ve Video Galerisi
              </span>

              <h1 className="mt-5 text-3xl md:text-5xl font-extrabold tracking-tight text-[#1f160f]">
                {pageTitle} Medya Galerisi
              </h1>

              <p className="mx-auto mt-5 max-w-3xl text-base md:text-lg leading-8 text-gray-700">
                Abone Halı Yıkama olarak sunduğumuz hizmetlerde gerçek çalışma
                süreçlerinden alınmış fotoğraf ve video içeriklerini bu sayfada
                inceleyebilirsiniz. Hijyen, profesyonel ekipman ve titiz işçilik
                anlayışımızı görsellerle daha net değerlendirebilirsiniz.
              </p>

              <div className="mt-7 flex flex-col sm:flex-row justify-center gap-3">
                <a
                  href="tel:05015336066"
                  className="rounded-full bg-[#2f160b] px-7 py-3 text-sm font-bold text-[#f8e6b2] shadow-lg hover:scale-105 transition"
                >
                  Hemen Ara (0501 533 60 66)
                </a>

                <a
                  href="https://wa.me/905015336066"
                  className="rounded-full bg-green-600 px-7 py-3 text-sm font-bold text-white shadow-lg hover:scale-105 transition"
                >
                  WhatsApp Teklif Al
                </a>
              </div>
            </div>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="rounded-2xl border border-[#ead9b7] bg-white/90 p-5 text-center shadow-[0_18px_45px_rgba(15,23,42,0.08)]">
                <p className="text-3xl font-extrabold text-[#2b160b]">
                  {mediaItems.length}
                </p>
                <p className="mt-1 text-sm font-semibold text-gray-600">
                  Toplam Medya
                </p>
              </div>

              <div className="rounded-2xl border border-[#ead9b7] bg-white/90 p-5 text-center shadow-[0_18px_45px_rgba(15,23,42,0.08)]">
                <p className="text-3xl font-extrabold text-[#2b160b]">
                  {imageCount}
                </p>
                <p className="mt-1 text-sm font-semibold text-gray-600">
                  Fotoğraf
                </p>
              </div>

              <div className="rounded-2xl border border-[#ead9b7] bg-white/90 p-5 text-center shadow-[0_18px_45px_rgba(15,23,42,0.08)]">
                <p className="text-3xl font-extrabold text-[#2b160b]">
                  {videoCount}
                </p>
                <p className="mt-1 text-sm font-semibold text-gray-600">
                  Video
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 pb-16">
          <div className="max-w-screen-xl mx-auto">
            <div className="mb-8 flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/galeri/koltuk-yikama"
                className={`rounded-full px-5 py-2 text-sm font-bold transition ${
                  normalizedSlug === "koltuk-yikama"
                    ? "bg-[#2f160b] text-[#f8e6b2]"
                    : "bg-white text-gray-700 border border-[#ead9b7] hover:bg-[#fff7df]"
                }`}
              >
                Koltuk Yıkama
              </Link>

              <Link
                to="/galeri/hali-yikama"
                className={`rounded-full px-5 py-2 text-sm font-bold transition ${
                  normalizedSlug === "hali-yikama"
                    ? "bg-[#2f160b] text-[#f8e6b2]"
                    : "bg-white text-gray-700 border border-[#ead9b7] hover:bg-[#fff7df]"
                }`}
              >
                Halı Yıkama
              </Link>

              <Link
                to="/galeri/videolar"
                className={`rounded-full px-5 py-2 text-sm font-bold transition ${
                  normalizedSlug === "videolar"
                    ? "bg-[#2f160b] text-[#f8e6b2]"
                    : "bg-white text-gray-700 border border-[#ead9b7] hover:bg-[#fff7df]"
                }`}
              >
                Videolar
              </Link>
            </div>

            {mediaItems.length === 0 ? (
              <div className="rounded-[28px] border border-red-100 bg-white p-8 text-center shadow">
                <p className="text-red-600 font-bold">Hiç medya bulunamadı.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {mediaItems.map((item, i) => (
                  <div
                    key={`${item.src}-${i}`}
                    className="group overflow-hidden rounded-[26px] border border-[#ead9b7] bg-white/95 shadow-[0_18px_45px_rgba(15,23,42,0.09)] transition duration-500 hover:-translate-y-1 hover:shadow-[0_25px_65px_rgba(15,23,42,0.16)]"
                  >
                    <div className="relative aspect-[4/3] overflow-hidden bg-[#f7f1e7]">
                      {item.type === "image" ? (
                        <img
                          src={item.src}
                          loading="lazy"
                          width={500}
                          height={375}
                          onClick={() => setSelectedImage(item.src)}
                          className="h-full w-full cursor-pointer object-cover transition duration-700 group-hover:scale-110"
                          alt={`${pageTitle} Abone Halı Yıkama görsel ${i + 1}`}
                        />
                      ) : (
                        <video
                          controls
                          preload="metadata"
                          className="h-full w-full object-cover"
                        >
                          <source src={item.src} type="video/mp4" />
                          Tarayıcınız video etiketini desteklemiyor.
                        </video>
                      )}

                      <div className="absolute left-3 top-3 rounded-full bg-black/60 px-3 py-1 text-xs font-bold text-white backdrop-blur">
                        {item.type === "image" ? "Fotoğraf" : "Video"}
                      </div>
                    </div>

                    <div className="p-4">
                      <p className="text-sm font-extrabold text-[#2b160b]">
                        Abone Halı Yıkama
                      </p>
                      <p className="mt-1 text-sm leading-6 text-gray-600">
                        {pageTitle} hizmetimize ait gerçek çalışma içeriği.
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="mt-12 rounded-[30px] border border-[#ead9b7] bg-white/90 p-6 md:p-8 shadow-[0_20px_60px_rgba(15,23,42,0.08)]">
              <h2 className="text-2xl md:text-3xl font-extrabold text-[#1f160f]">
                Hizmet Kalitemizi Görsellerle İnceleyin
              </h2>
              <p className="mt-4 text-base md:text-lg leading-8 text-gray-700 text-justify">
                Bu galeri sayesinde firmamızın çalışma prensiplerini, kullanılan
                ekipmanları ve temizlik sonrası ortaya çıkan sonuçları doğrudan
                gözlemleyebilirsiniz. Abone Halı Yıkama olarak amacımız,
                müşterilerimizin hizmet almadan önce güvenle karar verebilmesini
                sağlamaktır.
              </p>
            </div>
          </div>
        </section>
      </main>

      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/85 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative max-w-5xl w-full"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute -top-12 right-0 text-white text-4xl leading-none"
              aria-label="Görseli kapat"
            >
              ×
            </button>

            <img
              src={selectedImage}
              alt="Abone Halı Yıkama büyük görsel"
              className="w-full max-h-[88vh] object-contain rounded-2xl bg-white"
            />
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default GaleryPage;